import {
    GET_LOSTMEMBER_INFO_LOADING, LOSTMEMBER_DATA_SUCCESS,
    LOSTMEMBER_DATA_ERROR, LOSTMEMBER_DATA_RESET
} from "../actions/actionLostMember";

const initialState = {
    emailsend: false,
    loading: false,
    lostmemberError: ''
};

function reducerLostMember(state = initialState, action) {

    switch (action.type) {
        case GET_LOSTMEMBER_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }


        case LOSTMEMBER_DATA_SUCCESS: {

            return {
                ...state,
                emailsend: true,
                lostmemberError: ''
            };
        }

        case LOSTMEMBER_DATA_ERROR: {

            return {
                ...state,
                lostmember: false,
                lostmemberError: action.error
            };
        }

        case LOSTMEMBER_DATA_RESET: {

            return {
                ...state,
                loading: false,
                emailsend: false,
                lostmemberError: ''
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerLostMember;